import styled from 'styled-components';
import { breakpoints, css } from 'src/styles/theme';
import SummaryDealerDetailsTemplate from './SummaryDealerDetailsTemplate';
import { rem } from 'polished';
import { Pages } from '../../types/pages';

export const SummaryDealerDetailsStyled = styled(SummaryDealerDetailsTemplate)`
    border-bottom: ${rem('1px')} solid ${({ theme }) => theme.colors.black};
    border-top: ${rem('1px')} solid ${({ theme }) => theme.colors.black};

    ${({ page }) =>
        page === Pages.summary &&
        css`
            border-bottom: unset;
            @media (min-width: ${breakpoints.sm}px) {
                border-bottom: ${rem('1px')} solid ${({ theme }) => theme.colors.black};
            }
        `}

    &.isOpen {
        padding-bottom: ${rem('20px')};
    }

    .Collapsible__contentInner {
        .container {
            display: flex;
            font-size: ${rem('14px')};
            width: 100%;
            justify-content: space-between;
            flex-direction: column;

            @media (min-width: ${breakpoints.sm}px) {
                flex-direction: row;
            }

            .map {
                width: ${rem('384px')};
                height: ${rem('200px')};
                display: none;

                @media (min-width: ${breakpoints.sm}px) {
                    display: block;
                }
            }

            .info {
                display: flex;
                width: ${rem('384px')};
                flex-direction: column;
                color: ${({ theme }) => theme.colors.grey5};
                text-transform: capitalize;

                .infoIcon {
                    margin: 0 0 0 ${rem('10px')};
                }

                .linkButton {
                    margin-bottom: ${rem('15px')};

                    &.viewOnMap {
                        display: flex;
                        @media (min-width: ${breakpoints.sm}px) {
                            display: none;
                        }
                    }
                }

                .item {
                    margin-bottom: ${rem('20px')};
                    display: flex;
                    align-items: center;
                }

                .addr {
                    display: flex;
                    flex-direction: column;
                    margin-bottom: ${rem('20px')};
                    line-height: 1.5;

                    .name {
                        font-weight: bold;
                    }
                }
            }
        }
    }

    .titleWrapperButton {
        width: 100%;
    }

    .titleWrapper {
        display: flex;
        text-transform: capitalize;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        width: 100%;
        padding: ${rem('20px')} 0 ${rem('20px')} 0;

        .title {
            font-size: ${({ theme }) => theme.fontSizes.textBig};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            color: ${({ theme }) => theme.colors.grey5};
            line-height: 1.4;
        }

        svg {
            height: ${rem(14)};
        }

        .isOpen {
            svg {
                path {
                    stroke: ${({ theme }) => theme.colors.red};
                    stroke-width: 2;
                }
            }
        }

        .isClose {
            svg {
                width: ${rem(25)};
                height: ${rem(25)};
                margin-right: ${rem(10)};
                path {
                    fill: ${({ theme }) => theme.colors.red};
                }
            }
        }
    }
`;
